import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';

const DetailPage = () => {
  const { id } = useParams();
  console.log(id);
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const { arrJob } = contextState;
  const { showFormattedDate, showStatus } = contextFunctions;
  console.log(arrJob);
  const filtered = arrJob.find((el) => el.id === Number(id));
  console.log(filtered);
  return (
    <div className="container mb-5 pt-5">
      <div class=" row card mb-5">
        <div class="row g-0">
          <div class="col-12 img-detail">
            <img
              src={filtered.company_image_url}
              class="img-fluid rounded-start imgdetail"
              alt="Foto Perusahaan"
            />
          </div>
          <div class="col-12">
            <div class="card-body row">
              <h5 class="card-title fw-bold fs-2">{filtered.company_name}</h5>
              <p class="card-text col-12">
                <span className="fw-bolder">Posisi: </span>
                {filtered.title}
              </p>
              <p class="card-text col-12">
                <span className="fw-bolder">Job Desc: </span>
                {filtered.job_description}
              </p>
              <p class="card-text col-md-6">
                <span className="fw-bolder">Persyaratan/Kualifikasi: </span>
                {filtered.job_qualification}
              </p>
              <p class="card-text col-md-6">
                <span className="fw-bolder">Kota: </span>
                {filtered.company_city}
              </p>
              <p class="card-text col-md-6">
                <span className="fw-bolder">Tipe Kerja: </span>
                {filtered.job_type}
              </p>
              <p class="card-text col-md-6">
                <span className="fw-bolder">Tipe Kontrak: </span>
                {filtered.job_tenure}
              </p>

              <p class="card-text col-md-4">
                <span className="fw-bolder">Min Gaji: </span>
                {filtered.salary_min}
              </p>
              <p class="card-text col-md-4">
                <span className="fw-bolder">Max Gaji: </span>
                {filtered.salary_max}
              </p>
              <p class="card-text col-md-4">
                <span className="fw-bolder">Status: </span>
                {showStatus(filtered.job_status)}
              </p>
              <p class="card-text ms-1">
                <small class="text-muted">
                  Last updated {showFormattedDate(filtered.updated_at)}
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPage;
